import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { RecommendationService } from '../../../../core/services/recommendation.service';
import { EventService } from '../../../../core/services/event.service';
import { FuseDeleteDialogComponent } from '../../../../core/components/delete-dialog/delete-dialog.component';
import { SubscriptionService } from '../../../../core/services/subscription.service';

@Component({
  selector: 'recommended-blog',
  templateUrl: './recommended-blog.component.html',
  styleUrls: ['./recommended-blog.component.scss'],
  standalone: false
})

export class RecommendedBlogComponent implements OnInit {
  @Input() blog: any;
  @Input() index: any;
  @Output() deleteBlog = new EventEmitter();
  @Output() removeFavorite = new EventEmitter();
  public videoUrl;

  constructor(private _sanitizer: DomSanitizer, public snackBar: MatSnackBar,
              private translate: TranslateService, public dialog: MatDialog,
              private recommendationService: RecommendationService,
              private eventService: EventService, private subscriptionService: SubscriptionService) {
  }

  ngOnInit() {
    if (this.blog.video) {
      if (this.blog.video.indexOf('embed') !== -1) {
        this.videoUrl = this._sanitizer.bypassSecurityTrustResourceUrl(
          this.blog.video
        );
      } else {
        this.videoUrl = this._sanitizer.bypassSecurityTrustResourceUrl(
          this.parseYoutube(this.blog.video)
        );
      }
    } else {
      this.videoUrl = '';
    }
  }

  parseYoutube (url) {
    let link = 'https://www.youtube.com/embed/';
    const videoId = url.split('?v=');
    link = link + videoId[ 1 ];
    return link;
  }

  toggleFavorite(blog) {
    if (blog.isFavorite && blog.favId) {
      this.recommendationService.removeFavoriteRecommendation(blog.favId).subscribe((result) => {
        blog.isFavorite = false;
        blog.favId = null
        this.removeFavorite.emit(this.index);
      });
    } else {
      let data = {
        recommendationId: blog.id,
      }
      this.recommendationService.addFavoriteRecommendation(data).subscribe((result: any) => {
        blog.isFavorite = true;
        blog.favId = result.id;
      });
    }
  }

  getImage(name) {
    return this.eventService.getFileStream(name);
  }

  subscriptionToBlog (id, index) {
    const dialogRef = this.dialog.open(FuseDeleteDialogComponent , { panelClass: 'unsave-form-dialog',
      width: '300px' ,
      data: {title: 'blog.subscribe_to_blog' , message: 'blog.subscription_question'}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.subscriptionService.addBlogSubscription({blogId: id}).subscribe((res) => {
          if (res) {
            this.deleteBlog.emit(index);
            let message = this.translate.instant('blog.subscription_confirm_message');
            this.snackBar.open(message , 'OK' , {
              verticalPosition: 'top' ,
              panelClass: 'sub-to-event-bar'
            });
          }
        });
      }
    });
  }
}
